var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smooth",attrs:{"id":"app"}},[(this.$router.history.current.name != 'login')?_c('div',{staticClass:"wrapper"},[_c('Sidebar'),_c('div',{staticClass:"content"},[_c('Navbar'),_c('div',{staticClass:"content-body p-4 scroll-bar smooth",attrs:{"onscroll":"sc()"}},[_c('router-view')],1)],1)],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }